import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DialogBox from "../component/DialogBox";
import { IoIosArrowForward } from "react-icons/io";
import ButtonCompo from "../component/ButtonCompo";
import SelectField from "../component/SelectField";
import { DatePicker, StaticDatePicker } from "@mui/x-date-pickers";
import AlertBox from "../component/AlertBox";
import axios from "axios";
import { SERVER_URL } from "../constant";
import dayjs from "dayjs";
import { ServerDay } from "../component/utils/HighlightDates";
import RadioCompo from "../component/RadioCompo";
import { useSelector } from "react-redux";

function Cards({ title, available, accrued, credited, annual, total }) {
  return (
    <section className="border p-5 rounded-[10px] shadow-md hover:shadow-lg cursor-pointer">
      <h2 className="text-[16px] font-medium text-slate-500">{title}</h2>
      {available != undefined && (
        <div className="mt-3">
          <p className="text-slate-800">Available</p>
          <p className="text-[30px] font-bold">{available}</p>
        </div>
      )}
      <div className="mt-3 space-y-2">
        {title !== "Comp Off" && (
          <p className="justify-between flex text-[15px] items-center w-full text-slate-500 font-medium">
            Accrued so far this year{" "}
            <span className="text-slate-500 font-medium">{accrued}</span>
          </p>
        )}
        {credited !== undefined && (
          <p className="justify-between flex text-[15px] items-center w-full text-slate-500 font-medium">
            Credited from last year{" "}
            <span className="text-slate-500 font-medium">{credited}</span>
          </p>
        )}
        {annual && (
          <p className="justify-between flex text-[15px] items-center w-full text-slate-500 font-medium">
            Annual Allotment{" "}
            <span className="text-slate-500 font-medium">{annual}</span>
          </p>
        )}
        {total && (
          <p className="justify-between flex text-[15px] items-center w-full text-slate-500 font-medium">
            Total Allotment{" "}
            <span className="text-slate-500 font-medium">{total}</span>
          </p>
        )}
      </div>
    </section>
  );
}

function LeaveApplications() {
  const [enableLeaveApplicationForm, setEnableLeaveApplicationForm] =
    useState(false);
  const [leaveAccountData, setLeaveAccountData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [holidayData, setHolidayData] = useState([]);
  const [selectedLeaveType, setSelectedLeaveType] = useState("");
  const [selectedStartDate, setSelectedStartDate] = useState(
    dayjs().add(1, "day")
  );
  const [selectedEndDate, setSelectedEndDate] = useState(dayjs().add(1, "day"));
  const [selectedTotalDays, setSelectedTotalDays] = useState(0);
  const [selectedLeaveOption, setSelectedLeaveOption] = useState("Full");
  const [selectedDescription, setSelectedDescription] = useState("");
  const [enableLeaveOption, setEnableLeaveOption] = useState(true);
  const employeeData = useSelector((state) => state.employee?.employeeData);
  const [tableSwitch, setTableSwitch] = useState("LH");
  const [myApplications, setMyApplications] = useState([]);
  const [reload, setReload] = useState(false);
  const [leaveHist, setLeaveHist] = useState([]);
  const [recordData, setRecordData] = useState([]);

  // fetch leave structure
  async function getLeaveStructure() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/get/leave/account`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setLeaveAccountData(res.data?.data);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Leave structure fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // fetch holidays
  async function getHolidays() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/get/holidays`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setHolidayData(res.data?.data);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Holidays fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // fetch my leave applications
  async function getLeaveApplications() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/leave/get/all/applications`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setMyApplications(res.data?.data);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Holidays fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // fetch my leave history
  async function getLeaveHistory() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/leave/get/all/all`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setLeaveHist(res.data?.data);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Leave history fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // fetch my comp off records
  async function getCompOffRecords() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/get/all/comp-off/records`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setRecordData(res.data?.data);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Comp off records fetch failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getLeaveStructure();
    getHolidays();
  }, []);

  useEffect(() => {
    getLeaveApplications();
    getLeaveHistory();
    getCompOffRecords();
  }, [reload, tableSwitch]);

  // highlighted dates
  let highlightedDays = [];

  // parsing dates from DB to a standard way to show in the calender as highlighted
  holidayData?.map((leave) => {
    let date;
    // if there is only 1 leave day
    if (leave?.totalDays === 1) {
      date = `${leave?.startYear}-${(Number(leave?.startMonth) + 1)
        .toString()
        .padStart(2, "0")}-${leave?.startDom}`;
      highlightedDays.push(date);
    } else {
      // if there is more than 1 leave day
      // make that dates to "Date" type
      let currentDate = dayjs(
        `${leave?.startYear}-${(Number(leave?.startMonth) + 1)
          .toString()
          .padStart(2, "0")}-${leave?.startDom}`
      );
      // I subtract 1 from date because the last date is not a leave day. THe work will be resumed from that day.
      let endDate = dayjs(
        `${leave?.endYear}-${(Number(leave?.endMonth) + 1)
          .toString()
          .padStart(2, "0")}-${Number(leave?.endDom) - 1}`
      );

      // iterate
      while (currentDate <= endDate) {
        // push date
        highlightedDays.push(
          `${currentDate.$y}-${Number(currentDate.$M) + 1}-${currentDate.$D
            .toString()
            .padStart(2, "0")}`
        );
        //console.log(currentDate);
        // update date by 1 day
        currentDate = currentDate.add(1, "day");
      }
    }
  });

  // apply for leave
  async function applyLeave() {
    if (
      selectedDescription?.length === 0 ||
      selectedLeaveType?.length === 0 ||
      selectedTotalDays === 0
    ) {
      setOpen(true);
      setSuccess(false);
      setMessage(
        "Please fill all the field and select valid duration of leave"
      );
      return null;
    }
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/leave/apply`,
        method: "post",
        data: {
          description: selectedDescription,
          startDate: selectedStartDate?.$d,
          endDate: selectedEndDate?.$d,
          totalDays: selectedTotalDays,
          leaveOption: selectedLeaveOption,
          leaveType: selectedLeaveType,
        },
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setEnableLeaveApplicationForm(false);
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Leave applied successfully");
        setSelectedTotalDays(1);
        setSelectedLeaveOption("Full");
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // leave type array
  let leaveTypeArray = [];

  leaveAccountData?.map((leave) => {
    if (leave?.title !== "Unpaid" && leave?.title !== "Comp Off") {
      let newObj = {
        title: leave?.title,
        value: leave?.leaveId,
      };
      leaveTypeArray.push(newObj);
    }
  });

  // adding unpaid and comp off
  const unpaidCompOff = [
    {
      title: "Unpaid",
      value: "unpaid",
    },
    {
      title: "Comp Off",
      value: "compOff",
    },
  ];

  leaveTypeArray.push(...unpaidCompOff);

  // leave duration
  const leaveDurationArray = [
    {
      title: "Full Day",
      value: "Full",
    },
    {
      title: "First Half",
      value: "FH",
    },
    {
      title: "Second Half",
      value: "SH",
    },
  ];

  // calculation of total days
  useEffect(() => {
    const date1 = Date.UTC(
      selectedStartDate?.$y,
      selectedStartDate?.$M,
      selectedStartDate?.$D
    );
    const date2 = Date.UTC(
      selectedEndDate?.$y,
      selectedEndDate?.$M,
      selectedEndDate?.$D
    );

    // subtract
    const milisec = date2 - date1;

    // convert milisec to days
    /* let me explain why I add 1 to days. 
    In general, we calcuate days like 1/1/2023 to 2/1/2023 is 1 day. 
    But here, in the leave structure, it assumed as 2 days like 
    you are on leave on 1 and 2 also. That's why we need to add 1.
    */
    const days = Math.floor(milisec / (1000 * 60 * 60 * 24)) + 1;

    if (days <= 0) {
      setSelectedTotalDays(0);
      return;
    }

    setSelectedTotalDays(days);
    setSelectedLeaveOption("Full");
  }, [selectedStartDate, selectedEndDate]);

  // set total days 0.5 if there is half day
  useEffect(() => {
    if (selectedLeaveOption === "FH" || selectedLeaveOption === "SH") {
      setSelectedTotalDays(0.5);
    } else {
      setSelectedTotalDays(1);
    }
  }, [selectedLeaveOption]);

  // control leave option visibility
  useEffect(() => {
    if (selectedTotalDays === 1 || selectedTotalDays === 0.5) {
      setEnableLeaveOption(true);
    } else {
      setEnableLeaveOption(false);
      setSelectedLeaveOption("Full");
    }
  }, [selectedTotalDays]);

  // table switch
  const tableSwitchArray = [
    {
      title: "My Leave History",
      value: "LH",
    },
    {
      title: "My Leave Applications",
      value: "LA",
    },
    {
      title: "My Comp OFF Records",
      value: "COR",
    },
  ];

  if (enableLeaveApplicationForm) {
    return (
      <>
        {loading && (
          <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
        )}
        <div className="w-full flex justify-center items-center py-5">
          {success && (
            <AlertBox
              open={open}
              setOpen={setOpen}
              success={success}
              title={message}
            />
          )}
          {!success && (
            <AlertBox
              open={open}
              setOpen={setOpen}
              success={success}
              title={message}
            />
          )}
          <div className="w-[90vw] lg:w-[40rem]">
            <h1 className="text-[30px] font-medium text-left w-full">
              Apply For Leave
            </h1>
            <div className="w-full mt-5 space-y-5">
              <SelectField
                label={"Leave Type"}
                valueArray={leaveTypeArray}
                value={selectedLeaveType}
                setValue={(e) => setSelectedLeaveType(e?.target?.value)}
              />
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                <DatePicker
                  label="From"
                  onChange={(e) => setSelectedStartDate(e)}
                  value={selectedStartDate}
                  shouldDisableDate={(date) => {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0); // Reset time to compare only dates
                    return date <= today; // Disable past dates and today
                  }}
                />
                <DatePicker
                  label="To"
                  onChange={(e) => setSelectedEndDate(e)}
                  value={selectedEndDate}
                  shouldDisableDate={(date) => {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0); // Reset time to compare only dates
                    return date <= today; // Disable past dates and today
                  }}
                />
                <TextField
                  label="Total Days"
                  value={selectedTotalDays}
                  readOnly
                />
              </div>
              {enableLeaveOption === true ? (
                <RadioCompo
                  label={"Choose Leave Option"}
                  valueArray={leaveDurationArray}
                  onChange={(e) => setSelectedLeaveOption(e?.target?.value)}
                  value={selectedLeaveOption}
                />
              ) : (
                <RadioCompo
                  label={"Choose Leave Option"}
                  valueArray={[{ title: "Full Day", value: "Full" }]}
                  value={selectedLeaveOption}
                />
              )}
              <TextField
                label="Description"
                multiline
                className="!w-full"
                onChange={(e) => setSelectedDescription(e?.target?.value)}
              />
              {selectedTotalDays === 0 ? (
                <p className="mt-3 text-red-600">* Please select valid dates</p>
              ) : (
                ""
              )}
              <div className="flex w-full justify-end items-center gap-3">
                <ButtonCompo
                  variant={"outlined"}
                  onClick={() => setEnableLeaveApplicationForm(false)}
                >
                  Back
                </ButtonCompo>
                <ButtonCompo variant={"contained"} onClick={applyLeave}>
                  Apply
                </ButtonCompo>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center py-5">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw]">
          <h1 className="text-[30px] font-medium text-left w-full">
            Leave & Holidays
          </h1>
          <div className="flex justify-end w-full mt-5 gap-3">
            <ButtonCompo
              variant={"outlined"}
              onClick={() => setEnableLeaveApplicationForm(true)}
            >
              Apply For Leave
            </ButtonCompo>
          </div>
          <div className="w-full mt-5 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 gap-3">
            {leaveAccountData?.map((e, i) => (
              <Cards
                title={e?.title}
                available={e?.available}
                accrued={e?.taken}
                credited={e?.credited}
                annual={e?.totalDays}
              />
            ))}
          </div>
          <div className="mt-5">
            <RadioCompo
              valueArray={tableSwitchArray}
              value={tableSwitch}
              onChange={(e) => setTableSwitch(e?.target?.value)}
            />
          </div>
          <div className="flex mt-5 gap-5 justify-start items-start">
            {tableSwitch === "LH" ? (
              <div
                className="w-[100%] md:w-[60%] border rounded-[10px] overflow-auto"
                style={{ scrollbarWidth: "none" }}
              >
                <section className="p-4 bg-blue-500 text-white">
                  <h3 className="font-medium">My Leave History</h3>
                </section>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className="!text-center">Start Date</TableCell>
                      <TableCell className="!text-center">End Date</TableCell>
                      <TableCell className="!text-center">Leave Type</TableCell>
                      <TableCell className="!text-center">Status</TableCell>
                      <TableCell className="!text-center">Total Days</TableCell>
                      <TableCell className="!text-center">Purpose</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {leaveHist.map((e, i) => (
                      <TableRow
                        key={i}
                        className="hover:bg-slate-100/50 cursor-pointer"
                      >
                        <TableCell className="!text-center">{`${e?.startDom}-${
                          Number(e?.startMonth) + 1
                        }-${e?.startYear}`}</TableCell>
                        <TableCell className="!text-center">{`${e?.endDom}-${
                          Number(e?.endMonth) + 1
                        }-${e?.endYear}`}</TableCell>
                        <TableCell className="!text-center">
                          {e?.leaveName?.length > 0
                            ? e?.leaveName
                            : e?.leaveType}
                        </TableCell>
                        <TableCell className="!text-center">
                          {e?.isApproved === undefined ? (
                            <span className="bg-yellow-200/50 text-yellow-700 px-3 py-1 rounded-full font-medium">
                              Pending
                            </span>
                          ) : e?.isApproved === true ? (
                            <span className="bg-green-200/50 text-green-700 px-3 py-1 rounded-full font-medium">
                              Approved
                            </span>
                          ) : e?.isRevoked === true ? (
                            <span className="bg-red-200/50 text-red-700 px-3 py-1 rounded-full font-medium">
                              Revoked
                            </span>
                          ) : (
                            <span className="bg-red-200/50 text-red-700 px-3 py-1 rounded-full font-medium">
                              Denied
                            </span>
                          )}
                        </TableCell>
                        <TableCell className="!text-center">
                          {e?.totalDays}
                        </TableCell>
                        <TableCell className="!text-center">
                          {e?.description || "N/A"}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            ) : tableSwitch === "LA" ? (
              <div
                className="w-[100%] md:w-[60%] border rounded-[10px] overflow-auto"
                style={{ scrollbarWidth: "none" }}
              >
                <section className="p-4 bg-blue-500 text-white">
                  <h3 className="font-medium">My Leave Applications</h3>
                </section>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className="!text-center">Start Date</TableCell>
                      <TableCell className="!text-center">End Date</TableCell>
                      <TableCell className="!text-center">Leave Type</TableCell>
                      <TableCell className="!text-center">Status</TableCell>
                      <TableCell className="!text-center">Total Days</TableCell>
                      <TableCell className="!text-center">View</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {myApplications.map((e, i) => (
                      <TableRow
                        key={i}
                        className="hover:bg-slate-100/50 cursor-pointer"
                      >
                        <TableCell className="!text-center">{`${e?.startDom}-${
                          Number(e?.startMonth) + 1
                        }-${e?.startYear}`}</TableCell>
                        <TableCell className="!text-center">{`${e?.endDom}-${
                          Number(e?.endMonth) + 1
                        }-${e?.endYear}`}</TableCell>
                        <TableCell className="!text-center">
                          {e?.leaveName?.length > 0
                            ? e?.leaveName
                            : e?.leaveType}
                        </TableCell>
                        <TableCell className="!text-center">
                          {e?.isApproved === undefined ? (
                            <span className="bg-yellow-200/50 text-yellow-700 px-3 py-1 rounded-full font-medium">
                              Pending
                            </span>
                          ) : e?.isApproved === true ? (
                            <span className="bg-green-200/50 text-green-700 px-3 py-1 rounded-full font-medium">
                              Approved
                            </span>
                          ) : e?.isRevoked === true ? (
                            <span className="bg-red-200/50 text-red-700 px-3 py-1 rounded-full font-medium">
                              Revoked
                            </span>
                          ) : (
                            <span className="bg-red-200/50 text-red-700 px-3 py-1 rounded-full font-medium">
                              Denied
                            </span>
                          )}
                        </TableCell>
                        <TableCell className="!text-center">
                          {e?.totalDays}
                        </TableCell>
                        <TableCell className="!text-center">
                          <ButtonCompo
                            variant={"contained"}
                            href={`/leave/application/${e?._id}`}
                          >
                            View
                          </ButtonCompo>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            ) : (
              <div
                className="w-[100%] md:w-[60%] border rounded-[10px] overflow-auto"
                style={{ scrollbarWidth: "none" }}
              >
                <section className="p-4 bg-blue-500 text-white">
                  <h3 className="font-medium">My Comp OFF Records</h3>
                </section>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className="!text-center">Leave Date</TableCell>
                      <TableCell className="!text-center">Leave</TableCell>
                      <TableCell className="!text-center">Comp OFF Day</TableCell>
                      <TableCell className="!text-center">Total Working Hours</TableCell>
                      <TableCell className="!text-center">Status</TableCell>
                      <TableCell className="!text-center">View</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {recordData.map((e, i) => (
                      <TableRow
                        key={i}
                        className="hover:bg-slate-100/50 cursor-pointer"
                      >
                        <TableCell className="!text-center">{new Date(e?.leaveDate).toLocaleDateString("en-In")}</TableCell>
                        <TableCell className="!text-center">{e?.leaveName}</TableCell>
                        <TableCell className="!text-center">
                          {e?.totalDay}
                        </TableCell>
                        <TableCell className="!text-center">
                          {(Number(e?.totalWorikingHours) / 60).toFixed(2)} hours
                        </TableCell>
                        <TableCell className="!text-center">
                          {e?.isCanceled ? <p className="text-red-500 font-medium">Canceled</p> : "Not Canceled"}
                        </TableCell>
                        <TableCell className="!text-center">
                          <ButtonCompo
                            variant={"contained"}
                            href={`/single/comp-off/record/${e?._id}`}
                          >
                            View
                          </ButtonCompo>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            )}
            <div
              className="w-[40%] hidden md:block border rounded-[10px]"
              style={{ scrollbarWidth: "none" }}
            >
              <section className="p-4 bg-blue-500 text-white rounded-t-[10px]">
                <h3 className="font-medium">Total Holidays</h3>
              </section>
              <div className="w-full mt-5 hidden sm:flex justify-center items-center">
                <StaticDatePicker
                  orientation="portrait"
                  value={dayjs()}
                  slots={{
                    day: ServerDay,
                    actionBar: () => null,
                  }}
                  slotProps={{
                    day: {
                      highlightedDays,
                    },
                  }}
                  localeText={{
                    toolbarTitle: "Holiday Calender",
                  }}
                />
              </div>
              <div className="w-full px-0">
                {holidayData?.map((e, i) => (
                  <section className="flex justify-between items-center py-3 cursor-pointer hover:bg-slate-100 px-3">
                    <div>
                      <p className="text-[17px] font-medium">
                        {e?.description}{" "}
                        <span className="ml-1 text-[13px] bg-slate-200/80 px-2 py-1 rounded-full text-slate-700 font-medium">
                          {e?.totalDays > 1
                            ? `${e?.totalDays} days`
                            : `${e?.totalDays} day`}
                        </span>
                      </p>
                      <p className="text-[14px] text-slate-500 mt-2 font-medium">
                        {e?.totalDays > 1
                          ? `${e?.startDom?.toString()?.padStart(2, "0")}-${(
                              Number(e?.startMonth) + 1
                            )
                              ?.toString()
                              ?.padStart(2, "0")}-${e?.startYear} to ${e?.endDom
                              ?.toString()
                              ?.padStart(2, "0")}-${(Number(e?.endMonth) + 1)
                              ?.toString()
                              ?.padStart(2, "0")}-${e?.endYear}`
                          : `${e?.startDom?.toString()?.padStart(2, "0")}-${(
                              Number(e?.startMonth) + 1
                            )
                              ?.toString()
                              ?.padStart(2, "0")}-${e?.startYear}`}
                      </p>
                    </div>
                  </section>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LeaveApplications;
